import React, { useEffect } from 'react'
import { Route, Redirect, useLocation } from 'react-router-dom'
import qs from 'qs'
import { safeRedirectUri } from '../common/Utils'

const LoginRedirect = () => {
  const { search } = useLocation()
  const redirectUri = safeRedirectUri(qs.parse(search, { ignoreQueryPrefix: true }).redirect_uri || '')

  useEffect(() => {
    if (redirectUri !== '') window.location.replace(redirectUri)
  }, [redirectUri])

  return redirectUri === '' ? <Redirect to='/' /> : null
}

const LoggedInRedirector = (props) => {
  return (
    <>
      <Route exact path='/login'>
        <LoginRedirect />
      </Route>
      <Route exact path='/signup'>
        <Redirect to='/' />
      </Route>
    </>
  )
}

export default LoggedInRedirector
